// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectFloorTypeQueryResult, selectFloorTypesPageLoading, selectFloorTypesShowInitWaitingMessage} from '../_selectors/floor-type.selectors';

export class FloorTypesDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectFloorTypesPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectFloorTypesShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectFloorTypeQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
